import AddCircleIcon from "@mui/icons-material/AddCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import {
    noInternetMsg,
    saveFailedMsg,
    savemsg,
    saveWarningMsg,
    saveWarningMsgForClaimApplying,
    serverMsg
} from "../../config/messageconstant";
import { ClaimAttendanceJson } from "../../DynamicFormsJson/MastersJSON/claimAttendanceJson";
import {
    getOrderListByDate,
    setOrderListShowOrder,
} from "../../Slice/OrderHeaderList.slice";
import { getMonthlyClaimStatusBySalesTeam, setMonthlyClaimStatusBySalesTeam, getSalesTeamByReportingManagerId } from "../../Slice/salesExecutive.slice";
import { getStockStackHolders } from "../../Slice/StackHolder.slice";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { MyComponentWithIconProps } from "../../components/Comman/IconButton";
import endpoint from "../../config/endpoints";
import { apiGet, apiPost } from "../../utils/api_service";
import AddClaimPopUp from "./AddClaimPopUp";
import ClaimDetailsPopUp from "./ClaimDetailsPopUp";
import dayjs from "dayjs";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";

class ClaimAttendance extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
                salesTeamDetail: this.props.salesTeamList.salesExecutive,
            },
            addClaimPopUpFlag: false,
            claimDetailsPopUpFlag: false,
            claimDetailsData: {},
            addClaimData: {},
            searchValue: "",
            onSearchDataObj: {},
            addClaimType: "",
            formErrors: {},
            flag: "",
        };
    }
    async componentDidMount() {
        const { getSalesTeamByReportingManagerId, setMonthlyClaimStatusBySalesTeam, showNotification, showLoador } = this.props;
        if (navigator.onLine) {

            setMonthlyClaimStatusBySalesTeam({ row: [] });


            showLoador({ loador: true });
            await getSalesTeamByReportingManagerId({ managerId: "", flag: 1 }).then(
                ({ response, success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                }
            );
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }

    }



    componentWillReceiveProps(nextProps) {
        if (this.props.salesTeamList !== nextProps.salesTeamList) {
            if (
                this.props.salesTeamList?.salesExecutive !==
                nextProps.salesTeamList?.salesExecutive
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        salesTeamDetail: nextProps.salesTeamList?.salesExecutive,
                    },
                });
            }
        }
    }

    onSearch = (data) => {
        const { getMonthlyClaimStatusBySalesTeam, showLoador, showNotification } = this.props;

        if (navigator.onLine) {

            this.setState({ onSearchDataObj: data });

            showLoador({ loador: true });
            getMonthlyClaimStatusBySalesTeam({
                monthYear: data.month,
                salesTeamId: data.salesTeam,
            }).then(({ response, success }) => {
                console.log(response);
                showLoador({ loador: false });
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            }
            );

        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }

    }

    onClickAdd = (e, row) => {
        if (row.flag == 0) {
            this.props.showNotification({ msg: "User is absent", severity: "error", });
        } else {
            const { showLoador, showNotification } = this.props;

            let addClaimType = localStorage.getItem("isTaDaClaimAmountEditable");

            this.setState({ addClaimType, flag: row.flag });

            if (addClaimType && addClaimType == 1) {

                showLoador({ loador: true });
                apiGet({
                    url:
                        row.flag == 1 ?
                            endpoint.beat + "/day-end-beats-with-claim-status-with-edit-data?date="
                            + row.date + "&salesTeamId=" + row.id
                            : endpoint.beat + "/claim-details-for-day-end-beats-with-edited-data?date="
                            + row.date + "&salesTeamId=" + row.id,
                }).then(({ data, success }) => {
                    console.log(data.data);
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error", });
                    } else {
                        let rowData = {
                            ...data.data,
                            date: row.date !== null ? row.date : "-",
                            salesTeamId: row.id !== null ? row.id : "-",
                            salesTeamName: row.name !== null ? row.name : "-",
                            stockStakeHolderTypePrefix: row.stockStakeHolderTypePrefix !== null ? row.stockStakeHolderTypePrefix : "-",
                        };

                        this.setState({
                            addClaimPopUpFlag: true,
                            addClaimData: rowData
                        })
                    }
                });

            } else if (addClaimType && addClaimType == 2) {
                showLoador({ loador: true });
                apiGet({
                    url:
                        endpoint.beat + "/day-end-beats-with-ta-da-values?salesTeamId="
                        + row.id + "&&date=" + row.date + "&flag=1",
                }).then(({ data, success }) => {
                    console.log(data.data);
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error", });
                    } else {
                        if (data.data.workingBeats.length == 0 && data.data.notWorkingBeats.length == 0) {
                            showNotification({ msg: "No working found", severity: "error", });
                        } else {
                            let rowData = {
                                ...data.data,
                                date: row.date !== null ? row.date : "-",
                                salesTeamId: row.id !== null ? row.id : "-",
                                salesTeamName: row.name !== null ? row.name : "-",
                                stockStakeHolderTypePrefix: row.stockStakeHolderTypePrefix !== null ? row.stockStakeHolderTypePrefix : "-",
                                workingBeats: data.data.workingBeats !== null ? data.data.workingBeats.map((dataObj) => {
                                    return {
                                        ...dataObj,
                                        name: dataObj.beatName !== null ? dataObj.beatName : ""
                                    }
                                }) : [],
                                notWorkingBeats: data.data.notWorkingBeats !== null ? data.data.notWorkingBeats.map((dataObj) => {
                                    return {
                                        ...dataObj,
                                        name: dataObj.beatName !== null ? dataObj.beatName : ""
                                    }
                                }) : [],
                            };

                            this.setState({
                                addClaimPopUpFlag: true,
                                addClaimData: rowData
                            })
                        }


                    }
                });
            } else {
                if (
                    localStorage.getItem("dayEndUsingDailyAllowance") &&
                    localStorage.getItem("dayEndUsingDailyAllowance") == 1
                ) {

                    showLoador({ loador: true });
                    apiGet({
                        url:
                            endpoint.beat + "/day-end-claim-allowance-by-sales-team?date="
                            + row.date + "&salesTeamId=" + row.id,
                    }).then(({ data, success }) => {
                        console.log(data.data);
                        showLoador({ loador: false });
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error", });
                        } else {
                            let rowData = {
                                ...data.data,
                                date: row.date !== null ? row.date : "-",
                                salesTeamId: row.id !== null ? row.id : "-",
                                salesTeamName: row.name !== null ? row.name : "-",
                            };

                            this.setState({
                                addClaimPopUpFlag: true,
                                addClaimData: rowData
                            })
                        }
                    });
                } else if (
                    localStorage.getItem("dayEndUsingDailyAllowance") &&
                    localStorage.getItem("dayEndUsingDailyAllowance") == 2
                ) {
                    showLoador({ loador: true });
                    apiGet({
                        url:
                            endpoint.beat + "/day-end-beats-with-claim-status-by-sales-team?date="
                            + row.date + "&salesTeamId=" + row.id,
                    }).then(({ data, success }) => {
                        console.log(data.data);
                        showLoador({ loador: false });
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error", });
                        } else {
                            let rowData = {
                                ...data.data,
                                date: row.date !== null ? row.date : "-",
                                salesTeamId: row.id !== null ? row.id : "-",
                                salesTeamName: row.name !== null ? row.name : "-",
                                stockStakeHolderTypePrefix: row.stockStakeHolderTypePrefix !== null ? row.stockStakeHolderTypePrefix : "-",

                            };

                            this.setState({
                                addClaimPopUpFlag: true,
                                addClaimData: rowData
                            })
                        }
                    });
                }
            }
        }


    }

    onClickView = (e, row) => {
        const { showLoador, showNotification } = this.props;


        let addClaimType = localStorage.getItem("isTaDaClaimAmountEditable");
        this.setState({ addClaimType, flag: row.flag });


        if (row.flag == 0) {
            this.props.showNotification({ msg: "User is absent", severity: "error", });
        } else {
            showLoador({ loador: true });
            apiGet({
                url: addClaimType == 1 || addClaimType == 0 ?
                    endpoint.beat + "/claim-details-for-day-end-beats-with-edited-data?date="
                    + row.date + "&salesTeamId=" + row.id :
                    endpoint.beat + "/claim-details-for-day-end-beats?date="
                    + row.date + "&salesTeamId=" + row.id,
            }).then(({ data, success }) => {
                console.log(data.data);
                showLoador({ loador: false });
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error", });
                } else {

                    if (data.data.beatWorkInfo.length == 0) {
                        showNotification({ msg: "No working found", severity: "error", });
                    } else {
                        let rowData = {
                            ...data.data,
                            date: row.date !== null ? row.date : "-",
                            salesTeamId: row.id !== null ? row.id : "-",
                            salesTeamName: row.name !== null ? row.name : "-",
                            stockStakeHolderTypePrefix: row.stockStakeHolderTypePrefix !== null ? row.stockStakeHolderTypePrefix : "-",
                        };

                        this.setState({
                            claimDetailsPopUpFlag: true,
                            claimDetailsData: rowData
                        })
                    }
                }
            });
        }
    }

    handleCloses = () => {
        this.setState({ addClaimPopUpFlag: false, claimDetailsPopUpFlag: false })
    }


    checkValidation = () => {
        const { addClaimData } = this.state;
        let formErrors = {};
        let formIsValid = true;

        addClaimData.beatWorkInfo.forEach((dataObj, index) => {
            // dailyAllowance validation
            if (
                dataObj.dailyAllowance?.editedClaimAmt === null ||
                dataObj.dailyAllowance?.editedClaimAmt === ""
            ) {
                formIsValid = false;
                formErrors[`dailyAllowanceAmtError_${dataObj.id}`] = "DA amount required";
            }

            // travelAllowance validation
            if (
                dataObj.travelAllowance?.editedClaimAmt === null ||
                dataObj.travelAllowance?.editedClaimAmt === ""
            ) {
                formIsValid = false;
                formErrors[`travelAllowanceAmtError_${dataObj.id}`] = "TA amount required";
            }

            // remark validation
            if (!dataObj.remark || dataObj.remark.trim() === "") {
                formIsValid = false;
                formErrors[`remarkError_${dataObj.id}`] = "Remark is required";
            }
        });

        this.setState({ formErrors });
        return formIsValid;
    };



    onSubmitData = () => {
        const { showLoador, showNotification } = this.props;
        const { addClaimData, onSearchDataObj } = this.state;
        swal({
            title: "Are you sure?",
            text: saveWarningMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                apiPost({
                    url: endpoint.claimApplyHeader + "/save-on-click-for-sales-team?date="
                        + addClaimData.date + "&isDayEndClaim=0&salesTeamId=" + addClaimData.salesTeamId,
                    postBody: addClaimData.beatWorkInfo,
                }).then(({ data, success }) => {
                    showLoador({ loador: false });
                    if (success) {
                        if (data.data.statusCode == 500) {
                            showNotification({ msg: data.data.message, severity: "error", });
                        } else {
                            showNotification({ msg: data.data.message });
                            this.onSearch(onSearchDataObj);
                            this.setState({ addClaimPopUpFlag: false });
                        }
                    } else {
                        showNotification({
                            msg: saveFailedMsg,
                            severity: "error",
                        });
                    }
                });
            }
        });
    }

    onSubmitDataForEdit = () => {
        const { showLoador, showNotification } = this.props;
        const { addClaimData, onSearchDataObj, flag } = this.state;

        if (this.checkValidation()) {
            console.debug("addClaimData.beatWorkInfo-", addClaimData.beatWorkInfo)
            swal({
                title: "Are you sure?",
                text: saveWarningMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    showLoador({ loador: true });
                    apiPost({
                        url:
                            flag == 1 ?
                                endpoint.claimApplyHeader + "/save-on-click-with-edit?salesTeamId="
                                + addClaimData.salesTeamId + "&date=" + addClaimData.date + "&isDayEndClaim=0"
                                :
                                endpoint.claimApplyHeader + "/update-edited-claim-amt-and-header-status?status=0",
                        postBody: addClaimData.beatWorkInfo,
                    }).then(({ data, success }) => {
                        showLoador({ loador: false });
                        if (success) {
                            if (data.data.statusCode == 500) {
                                showNotification({ msg: data.data.message, severity: "error", });
                            } else {
                                showNotification({ msg: data.data.message });
                                this.onSearch(onSearchDataObj);
                                this.setState({ addClaimPopUpFlag: false });
                            }
                        } else {
                            showNotification({
                                msg: saveFailedMsg,
                                severity: "error",
                            });
                        }
                    });
                }
            });
        }

    }

    onSubmitDataWithDropDowns = (combinedSelectedBeats) => {
        const { addClaimData, onSearchDataObj } = this.state;
        const { showLoador, showNotification } = this.props;

        let flag = addClaimData && addClaimData?.claimBeats.length !== 0 ? 1 : 0;

        swal({
            title: "Are you sure?",
            text: flag == 1 ? saveWarningMsgForClaimApplying : saveWarningMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                apiPost({
                    url: endpoint.claimApplyHeader + "/save-on-click-for-multiple-claims?salesTeamId="
                        + addClaimData.salesTeamId + "&date=" + addClaimData.date + "&isDayEndClaim=0&flag=" + flag,
                    postBody: combinedSelectedBeats,
                }).then(({ data, success }) => {
                    showLoador({ loador: false });
                    if (success) {
                        if (data.data.statusCode == 500) {
                            showNotification({ msg: data.data.message, severity: "error", });
                        } else {
                            showNotification({ msg: data.data.message });
                            this.onSearch(onSearchDataObj);
                            this.setState({ addClaimPopUpFlag: false });
                        }
                    } else {
                        showNotification({
                            msg: saveFailedMsg,
                            severity: "error",
                        });
                    }
                });
            }
        });


    }

    onSearchBox = (searchValue) => {
        this.setState({
            searchValue: searchValue,
        });
    };

    getFilteredTableData = (searchData) => {
        const { searchValue } = this.state;
        return searchData.filter((currentRow) => {
            let isValid = false;
            if (
                (currentRow["date"] &&
                    currentRow["date"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["beatNames"] &&
                    currentRow["beatNames"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase()))
            ) {
                isValid = true;
                return true;
            }
        });
    };



    onTextFieldDataChange = (dataKey, uniqueId, value) => {
        const { addClaimData } = this.state;

        const keyToUpdate = dataKey === "da" ? "dailyAllowance" : "travelAllowance";

        const latestClaimData = addClaimData.beatWorkInfo.map((dataObj) => {
            // check only the allowance with matching id
            if (dataObj[keyToUpdate]?.id !== uniqueId) {
                return dataObj; // unchanged
            }

            const updatedAllowance = {
                ...dataObj[keyToUpdate],
                editedClaimAmt: value,
            };

            const updatedDataObj = {
                ...dataObj,
                [keyToUpdate]: updatedAllowance,
            };

            const daAmt = +updatedDataObj.dailyAllowance?.editedClaimAmt || 0;
            const taAmt = +updatedDataObj.travelAllowance?.editedClaimAmt || 0;

            return {
                ...updatedDataObj,
                totalEditedClaimAmt: daAmt + taAmt,
            };
        });

        const finalTotal = latestClaimData.reduce(
            (sum, obj) => sum + (obj.totalEditedClaimAmt || 0),
            0
        );

        const updatedClaimData = {
            ...addClaimData,
            beatWorkInfo: latestClaimData,
            finalTotal,
        };

        this.setState({ addClaimData: updatedClaimData });
        console.log(updatedClaimData);
    };

    onTextFieldDataChangeForRemark = (dataKey, value) => {
        const { addClaimData } = this.state;

        const latestClaimData = addClaimData.beatWorkInfo.map((dataObj) => {

            return {
                ...dataObj,
                remark: value,
            };
        });

        const updatedClaimData = {
            ...addClaimData,
            beatWorkInfo: latestClaimData,
        };

        this.setState({ addClaimData: updatedClaimData });
        console.log(updatedClaimData);
    };




    render() {
        const { salesTeamList } = this.props;
        const {
            dynamicMasterData,
            addClaimPopUpFlag,
            addClaimData,
            claimDetailsData,
            claimDetailsPopUpFlag,
            addClaimType,
            formErrors,
        } = this.state;

        return (
            <>
                <Paper
                    sx={{
                        padding: 2,
                    }}
                    elevation={0}
                >

                    <DynamicFormWithoutSave
                        dynamicMasterData={dynamicMasterData}
                        getListById={this.getListById}
                        searchList={ClaimAttendanceJson.searchList}
                        showSaveBtn={true}
                        showSaveBtnMain={false}
                        showTitle={ClaimAttendanceJson.showTitle}
                        screenTitle={ClaimAttendanceJson.screenTitle}
                        fieldMeta={ClaimAttendanceJson.fieldMeta}
                        showCancel={ClaimAttendanceJson.showCancel}
                        apiBaseURL={ClaimAttendanceJson.apiBaseURL}
                        showSaveNextBtn={ClaimAttendanceJson.showSaveNextBtn}
                        saveBtnText={"Search"}
                        onSave={this.onSearch}
                        isNote={
                            localStorage.getItem("userTypeId")
                                && localStorage.getItem("userTypeId") == 1
                                || localStorage.getItem("userTypeId") == 6
                                ? false : true}
                        isNoteValue={"If you want to view your own data, do not select a sales team."}
                    />
                    <br />


                    {salesTeamList?.monthlyClaimStatus.length !== 0 && (
                        <>
                            <LandingScreenHeader
                                screenTitle={""}
                                showSearchBox={true}
                                showTable={true}
                                showFilter={false}
                                showPdfDownload={false}
                                showExcelDownload={false}
                                onSearch={this.onSearchBox}
                            />
                            <TableContainer sx={{ maxHeight: 450 }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center" sx={{ width: "3%" }}>
                                                Sr. No
                                            </TableCell>
                                            <TableCell align="center" sx={{ width: "15%" }}>
                                                Date
                                            </TableCell>
                                            <TableCell align="center" sx={{ width: "15%" }}>
                                                Beat
                                            </TableCell>
                                            <TableCell align="center" sx={{ width: "15%" }}>
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.getFilteredTableData(salesTeamList?.monthlyClaimStatus).map((dataObj, indexRow) => {

                                            return (

                                                <TableRow>

                                                    <>
                                                        <TableCell width="10%" align="center">
                                                            {indexRow + 1}
                                                        </TableCell>
                                                        <TableCell align="center">{dataObj.date}</TableCell>
                                                        {dataObj.beatNames === "-" ? (
                                                            <TableCell align="center">{dataObj.beatNames}</TableCell>
                                                        ) : (
                                                            <TableCell align="left">{dataObj.beatNames}</TableCell>
                                                        )}
                                                        <TableCell align="center" >
                                                            {localStorage.getItem("isTaDaClaimAmountEditable") == 0 ? <>
                                                                <MyComponentWithIconProps
                                                                    statusImage={VisibilityIcon}
                                                                    color="primary"
                                                                    fontSize="medium"
                                                                    title="View"
                                                                    onClick={(e) => this.onClickView(e, dataObj)}
                                                                />
                                                            </> :
                                                                localStorage.getItem("isTaDaClaimAmountEditable") == 1 ?
                                                                    dataObj.date != dayjs().format("DD-MM-YYYY") && dataObj.claimStatus == 0 ?
                                                                        <>
                                                                            <MyComponentWithIconProps
                                                                                statusImage={AddCircleIcon}
                                                                                color="primary"
                                                                                fontSize="medium"
                                                                                title="Add Claim"
                                                                                onClick={(e) => this.onClickAdd(e, dataObj)}
                                                                            />
                                                                        </> :
                                                                        <MyComponentWithIconProps
                                                                            statusImage={VisibilityIcon}
                                                                            color="primary"
                                                                            fontSize="medium"
                                                                            title="View"
                                                                            onClick={(e) => this.onClickView(e, dataObj)}
                                                                        /> :
                                                                    localStorage.getItem("isTaDaClaimAmountEditable") == 2 ?
                                                                        dataObj.date != dayjs().format("DD-MM-YYYY") && dataObj.claimStatus == 0 ?
                                                                            <>
                                                                                <MyComponentWithIconProps
                                                                                    statusImage={AddCircleIcon}
                                                                                    color="primary"
                                                                                    fontSize="medium"
                                                                                    title="Add Claim"
                                                                                    onClick={(e) => this.onClickAdd(e, dataObj)}
                                                                                />
                                                                            </> :
                                                                            <MyComponentWithIconProps
                                                                                statusImage={VisibilityIcon}
                                                                                color="primary"
                                                                                fontSize="medium"
                                                                                title="View"
                                                                                onClick={(e) => this.onClickView(e, dataObj)}
                                                                            /> : ""}


                                                        </TableCell>

                                                    </>

                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </>
                    )}

                    {addClaimPopUpFlag && (
                        <>
                            <AddClaimPopUp
                                open={addClaimPopUpFlag}
                                addClaimType={addClaimType}
                                addClaimData={addClaimData}
                                handleCloses={this.handleCloses}
                                formErrors={formErrors}
                                onSubmitData={addClaimType == 1 ? this.onSubmitDataForEdit :
                                    addClaimType == 2 ? this.onSubmitDataWithDropDowns : this.onSubmitData
                                }
                                onTextFieldDataChange={this.onTextFieldDataChange}
                                onTextFieldDataChangeForRemark={this.onTextFieldDataChangeForRemark}
                            />
                        </>)}


                    {claimDetailsPopUpFlag && (
                        <>
                            <ClaimDetailsPopUp
                                open={claimDetailsPopUpFlag}
                                handleCloses={this.handleCloses}
                                claimDetailsData={claimDetailsData}
                                addClaimType={addClaimType}
                            />

                        </>
                    )}


                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    salesTeamList: state.salesExecutive
});
const mapDispatchToProps = {
    showNotification,
    showLoador,
    getStockStackHolders,
    getOrderListByDate,
    setOrderListShowOrder,
    getSalesTeamByReportingManagerId,
    getMonthlyClaimStatusBySalesTeam,
    setMonthlyClaimStatusBySalesTeam,
};
export default connect(mapStateToProps, mapDispatchToProps)(ClaimAttendance);
